export enum InvoiceStatus {
  BALANCE_DUE = 1,
  PAID = 2,
  INACTIVE = 3
}

/**
 * Converts an invoice status to text.
 * @param invoiceStatus - Accepts either "BALANCE_DUE", "PAID", "INACTIVE" or corresponding numeric values.
 * @returns A string representation of the invoice status.
 */
export const invoiceStatusToText = (invoiceStatus: string | number): string => {
  switch (invoiceStatus) {
    case InvoiceStatus.BALANCE_DUE:
    case 'BALANCE_DUE':
      return 'BALANCE DUE'
    case InvoiceStatus.PAID:
    case 'PAID':
      return 'PAID'
    case InvoiceStatus.INACTIVE:
    case 'INACTIVE':
      return 'INACTIVE'
    default:
      return 'Undefined'
  }
}
